export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13215.30647b86.jpg";